/* Keep draft story links in the same reviewed theme; no effect on live visitors. */
(() => {
  const connect = () => {
    const theme = new URLSearchParams(window.location.search).get('preview_theme_id')
      || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
    if (!theme || !/^\d+$/.test(theme)) return;
    document.querySelectorAll('#stories a[href]').forEach(link => {
      const url = new URL(link.href, window.location.origin);
      if (url.origin !== window.location.origin || !url.searchParams.get('view')?.startsWith('b4p-')) return;
      url.searchParams.set('preview_theme_id', theme);
      link.href = url.href;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect);
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();
